




















import { defineComponent, PropType, ref, useContext, useFetch, watch } from '@nuxtjs/composition-api';
import { GenericObjectType } from '~/utils/types';
import CheckBox from '~/components/solepro/ProductPage/PurchaseOptions/CrossSellCheckbox.vue';
import { DURATION_LABEL_KEYS } from '~/utils/constants/layout';
import Spinner from '~/components/solepro/Spinner.vue';
import axios from 'axios';
import { useConfig } from '~/composables';
import { getAxiosConfigs, isCurrentTrial } from '~/utils/solepro/functions';
import { ProductForProductPageType } from '~/utils/types/ProductPage';

export default defineComponent({
    props: {
        product: {
            type: Object as PropType<GenericObjectType>,// @TODO define component
            required: true,
        },
        frequency: {
            type: String
        },
        title: {
            type: String,
        },
    },
    components: {
        CheckBox,
        Spinner
    },
    setup(props, { emit }) {
        const { app, $fc } = useContext()
        const { i18n } = app;
        const { config } = useConfig()
        const isSelected = ref(false);
        const isLoading = ref(false);
        const p = props.product as GenericObjectType;
        const csp = ref<ProductForProductPageType>();
        const price = ref();
        const cspFrequency = ref(props.frequency);
        const onChange = (val: boolean, product: ProductForProductPageType) => {
            isSelected.value = val;
            emit('cross-sell-selected', {isAdded: val, product});
        };

        const getPrice = () => {
            
            const isCurrentPlanTrial = isCurrentTrial(csp.value, cspFrequency.value);


            if (isCurrentPlanTrial) {
                price.value = i18n.t('first cross_sell_price {price} {duration}', {
                    price: $fc(csp.value?.trialPrice),
                    duration: `${csp.value?.trialDuration} ${i18n.tc(DURATION_LABEL_KEYS[csp.value?.trialDurationSpan], csp.value?.trialDuration)}`,
                })
            } else if (csp.value?.promotional[cspFrequency.value]) {
                price.value = i18n.t("first cross_sell_price {price} {duration}", {
                    price: $fc(csp.value.promotional[cspFrequency.value].price),
                    duration: `${csp.value.promotional[cspFrequency.value].duration} ${i18n.tc(DURATION_LABEL_KEYS[cspFrequency.value], csp.value.promotional[cspFrequency.value].duration)}`,
                })
            } else if (csp.value?.discountedPrices[cspFrequency.value]) {
                price.value = i18n.t("periodic cross_sell_price {price} {duration}", {
                    price: $fc(csp.value.discountedPrices[cspFrequency.value]),
                    duration: `${i18n.tc(DURATION_LABEL_KEYS[cspFrequency.value], 1)}`,
                })
            } else if (csp.value?.prices[cspFrequency.value]) {
                price.value = i18n.t("periodic cross_sell_price {price} {duration}", {
                    price: $fc(csp.value.prices[cspFrequency.value]),
                    duration: `${i18n.tc(DURATION_LABEL_KEYS[cspFrequency.value], 1)}`,
                })
            } else if (csp.value?.price) {
                price.value = i18n.t('cross_sell_price {price}', {
                    price: $fc(csp.value?.price),
                })
            }
        }
        useFetch(async () => {
            isLoading.value = true;
            try {
                const { data } = await axios.get(`/sole-api/product/getProduct?sku=${p.sku}`, { ...getAxiosConfigs(app, config) });
                csp.value = data;
                cspFrequency.value = data.paymentFrequencies.includes(props.frequency) ? props.frequency : data.paymentFrequencies[0];
                //default checked
                //emit('cross-sell-selected', {isAdded: true, product:data});

                getPrice();
                isLoading.value = false;
            } catch (e) {
                isLoading.value = false;
            }
        })

        watch(() => props.frequency, (newFrequency) => {
            cspFrequency.value = csp.value.paymentFrequencies.includes(newFrequency) ? newFrequency : csp.value.paymentFrequencies[0];
            getPrice();
        })

        return {
            isLoading,
            csp,
            isSelected,
            onChange,
            price,
            cspFrequency
        };
    }
});
